// actions.js
export const sendTranscriptData = data => {
  return {
    type: 'SEND_TRANSCRIPT_DATA',
    payload: data
  };
};
